import _ from 'underscore';
import { getCellHeight } from './cell';
import Time from '../../lib/time';

const usePeriods = scheduledMeetings => {
	return scheduledMeetings.length > 0 && 
		scheduledMeetings[0].period !== undefined && 
		scheduledMeetings[0].period !== null;
};


const createHeaderCell = (index, name, duration) => {
	let cell = {
		index: index,
		name: name,
		duration: duration
	};

	cell.height = getCellHeight(cell);
	
	return cell;
};

const getPeriodLabels = (scheduledMeetings) => {
	return scheduledMeetings.reduce((periods, scheduledMeeting) => {
		let period = scheduledMeeting.period;
		
		if(!periods.entities[period]) {
			periods.entities[period] = true;
			periods.items.push(createHeaderCell(
				period,
				`PER \n ${period}`,
				scheduledMeeting.duration
			));
		}
		return periods;
	}, { items: [], entities: {} });
};

const getTimeLabels = ({timeInterval, startTime, endTime}) => {
	let headers = [];
	let name;

	startTime = Time.parse(startTime);
	endTime = Time.parse(endTime);
	name = Time.new(startTime.hour, startTime.minutes).value.replace(/\s*am|pm/, '');
	headers.push(createHeaderCell(startTime.hour, name, 60 - startTime.minutes));
	
	for(let hour=startTime.hour + 1; hour <= endTime.hour; hour++) {
		
		for(let minutes=0; minutes < 60; minutes += timeInterval) {
			if(hour === endTime.hour && minutes > endTime.minutes) {
				break;
			}
			name = Time.new(hour, minutes).value.replace(/\s*am|pm/, '');
			headers.push(createHeaderCell(hour, name, timeInterval));
		}
	}

	return headers;
};

export default function rowHeaders(props, scheduledMeetings) {
	if(usePeriods(scheduledMeetings)) {
		return _.sortBy(
			getPeriodLabels(scheduledMeetings).items, 
			item => item.period
		);
	}
	else {
		return getTimeLabels(props);
	}
};


/** WEBPACK FOOTER **
 ** ./src/js/lib/schedule_table/row_headers.js
 **/